import {UISidebarController} from '../../../ui_html/new_layout/UISidebarController'

export class UIDPrivacyPolicySceneController {
    private readonly sidebarController: UISidebarController
    private readonly privacyPolicySceneContainerDiv: HTMLDivElement

    constructor(sidebarController: UISidebarController) {
        this.sidebarController = sidebarController
        this.privacyPolicySceneContainerDiv = document.getElementById('scene_discord_privacy_policy_container') as HTMLDivElement
    }

    hide() {
        this.privacyPolicySceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.privacyPolicySceneContainerDiv.classList.remove('hidden')
        this.sidebarController.deactivateAllButtons()
    }
}
